import { createFileRoute } from "@tanstack/react-router";
import { RunsPage } from "../features/runs/runs-page";
import { validateRunsSearch } from "../features/runs/search";

export const Route = createFileRoute("/_app/w/$workspace/p/$project/runs/")({
  validateSearch: validateRunsSearch,
  component: RunsPage,
});
